module.exports = __webpack_public_path__ + "img/Momentum_Knok_Camera.da278fe4.png";